<template>
  <div>
    <h1>Membership Options</h1>
    <span v-html="joinOnlineIntro"></span>
  </div>
</template>

<script>
import { registrationConfig } from "../helpers/config";
export default {
  setup() {
    const { joinOnlineIntro } = registrationConfig;

    return {
      joinOnlineIntro,
    };
  },
};
</script>

<style lang="scss" scoped>
div {
  padding-top: 24px;
  margin-bottom: 24px;
  line-height: 28px;

  h1 {
    line-height: 36px;
  }

  a {
    color: var(--primary);
    text-decoration: none;
  }
}
</style>
